import inputStyles from "../../../styles/UI/inputFields.module.css";

type Direction = "ROW" | "COLUMN";

const InputNumberField = ({
  id,
  label,
  tailingLabel,
  value,
  placeholder,
  direction,
  onInputChange,
  disabled,
  classes,
  fieldWidth,
  max,
  min,
  minWidth,
}: {
  id: string;
  label: string;
  tailingLabel?: string;
  value?: string;
  placeholder: string;
  direction?: Direction;
  onInputChange: (value: string) => void;
  disabled?: boolean;
  classes?: string;
  fieldWidth?: string;
  max?: number;
  min?: number;
  minWidth?: string;
}) => {
  return (
    <label
      htmlFor={id}
      className={`flex gap-[var(--spacing-xs)] ${direction === "COLUMN" ? "flex-col" : "flex items-center"} ${classes ? classes : null}`}
    >
      <span className={`pl-2 ${inputStyles.label}`}>{label}</span>
      <div>
        <input
          style={{
            width: fieldWidth ? fieldWidth : "unset",
            minWidth: minWidth ? minWidth : "unset",
          }}
          className={inputStyles.inputFields}
          type="number"
          max={max}
          min={min}
          id={id}
          aria-label={placeholder}
          value={value}
          disabled={disabled}
          placeholder={placeholder}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            onInputChange(event.target.value);
          }}
          onBlur={() => {
            if (max !== undefined && Number(value) > max)
              onInputChange(String(max));
          }}
        />
        <span className={`pl-2 ${inputStyles.label}`}>{tailingLabel}</span>
      </div>
    </label>
  );
};

export default InputNumberField;
